import { useContext } from 'react';
import { LanguageContext } from './LanguageContext';

/**
 * Hook to access translations in functional components.
 *
 * Usage:
 * ```tsx
 * function MyComponent() {
 *   const { t, tPlural, language, setLanguage } = useTranslation();
 *
 *   return (
 *     <div>
 *       <h1>{t('common.save')}</h1>
 *       <p>{t('message.greeting', { name: 'John' })}</p>
 *
 *       {/* Pluralization: uses { singular, pl } format *}
 *       <p>{tPlural('devices.selected', selectedCount)}</p>
 *       {/* count=1: "1 Device Selected", count=5: "5 Devices Selected" *}
 *
 *       <button onClick={() => setLanguage('fr')}>Français</button>
 *     </div>
 *   );
 * }
 * ```
 */
export function useTranslation () {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }

  return context;
}
